import remove from 'lodash/remove';

import { createReducer } from '@/helpers/reducerUtils';

import * as constants from './actionTypes';

const initialState = {
  failure: false,
  errors: [],
  isRunning: false,
  addresses: [],
};

function profileUpdatedApply(state, payload) {
  const { error, failure } = payload;

  if (failure) {
    return {
      ...state,
      failure,
      error,
    };
  }

  return {
    ...state,
    failure,
    isRunning: false,
  };
}

function profileLoadingApply(state, isRunning) {
  return {
    ...state,
    isRunning,
  };
}

function addressCreatedApply(state, { failure, address, errors }) {
  if (failure) {
    return {
      ...state,
      failure,
      errors,
    };
  }

  return {
    ...state,
    failure,
    isRunning: false,
    addresses: [...state.addresses, address],
  };
}

function addressUpdateddApply(state, { failure, address, errors }) {
  const index = state.addresses.findIndex(
    (x) => x.addressId === address.addressId,
  );
  const { addresses } = state.addresses;

  addresses[index] = address;

  if (failure) {
    return {
      failure,
      errors,
    };
  }

  return {
    ...state,
    errors,
    failure,
    isRunning: false,
    addresses: [...addresses],
  };
}

function addressDeletedApply(state, { failure, addressId, errors }) {
  const { addresses } = state.addresses;

  if (failure) {
    return {
      failure,
      errors,
    };
  }

  if (addresses) {
    remove(addresses, (address) => address.addressId === addressId);
  }

  return {
    ...state,
    errors,
    failure,
    isRunning: false,
    addresses: [...addresses],
  };
}

const profileManagementReducer = createReducer(initialState, {
  [constants.PROFILEMGMT_PROFILE_UPDATED]: profileUpdatedApply,
  [constants.PROFILEMGMT_ADDRESS_CREATED]: addressCreatedApply,
  [constants.PROFILEMGMT_ADDRESS_UPDATED]: addressUpdateddApply,
  [constants.PROFILEMGMT_ADDRESS_DELTETED]: addressDeletedApply,
  [constants.PROFILEMGMT_ADDRESS_RUNNING]: profileLoadingApply,
});

export default profileManagementReducer;
